module.exports = __webpack_public_path__ + "img/gbwhatsapp-qr-code-gbwhatapks.414e0454.webp";